var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-list"},[(_vm.list.length > 0)?_c('div',_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('categoryCard',{attrs:{"item":item,"index":index},on:{"click":_vm.selectClick}})],1)}),0):_c('div',{staticClass:"blank-wrap"},[_c('Blank')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }